module.exports = __webpack_public_path__ + "img/failx400.webp";